import React from 'react';
import { useMediaQuery } from 'react-responsive';
import PricingContent from './PricingContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <PricingContent history={history} />
  </Mobile>
);

export default MobileResponsive;
